import * as React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button
} from '@mui/material';

const AlertDialog = ({ handleClose, dialogContentText, dialogTitle, open, showAcceptButton = true }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="xs" // XS mantiene el tamaño compacto tanto en PC como en móvil
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{ fontWeight: 'bold', textAlign: 'center', fontSize: '1.25rem' }}
      >
        {dialogTitle}
      </DialogTitle>
      <DialogContent>
        <div
          id="alert-dialog-description"
          style={{
            textAlign: 'left',
            fontSize: '1rem',
            wordBreak: 'break-word',
            padding: '10px 5px',
            lineHeight: 1.6
          }}
        >
          {dialogContentText}
        </div>
      </DialogContent>

        {showAcceptButton && (
        <DialogActions sx={{ justifyContent: 'center', paddingBottom: 2 }}>
          <Button onClick={handleClose} variant="contained" autoFocus>
            Aceptar
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default AlertDialog;
